import { DoctorSelectionProvider } from '@context/DoctorSelection';

import DoctorSelectionView from './views/DoctorSelectionView';

const DoctorSelection = () => {
  return (
    <DoctorSelectionProvider>
      <DoctorSelectionView />
    </DoctorSelectionProvider>
  );
};

export default DoctorSelection;
